<template>
	<div>
		<div
			class="border-15 cropped m-auto"
			:class="imgClass"
			:style="style()"
			@click = "$emit('click')"
		>
		<img 
		style="width: 28px;float: left;border-radius: 50%;border: 2px solid #fff;margin-top: -5px;margin-left: -5px;"
		alt=""
		v-if="level!='' && level!=0 && level!='0'"
		:src="require('../../assets/img/level_'+level+'.svg')"
		/>

<div 
class="text-center"
style="position: absolute; display: flex; align-items: flex-end;"
:style="vStyle +' '+ vWidth + ' max-width:' + imgSize+'; min-width:' + imgSize+'; height:' + imgSize" 
v-if="this.showImage() != img.Avatar"
>
	<img 
	:src="require('../../assets/img/Logo_admin.svg')"
	class="w-75 "
	style=" background-color: #ffffffb0; padding-top: 3px; padding-left: 10px; border-top-left-radius: 5px;"
	v-if="badge"
	/>
</div>

	</div>
	<div class="text-center mt-1" v-if="star!='جدید' && star!='' ">
	<img 
		:src="require('../../assets/img/star_'+((star>0)? 'on' : 'off')+'.svg')"
		style="width: 20px;"
		alt=""
	/>
	<img 
		:src="require('../../assets/img/star_'+((star>1)? 'on' : 'off')+'.svg')"
		style="width: 20px;"
		alt=""
	/>
	<img 
		:src="require('../../assets/img/star_'+((star>2)? 'on' : 'off')+'.svg')"
		style="width: 20px;"
		alt=""
	/>
	<img 
		:src="require('../../assets/img/star_'+((star>3)? 'on' : 'off')+'.svg')"
		style="width: 20px;"
		alt=""
	/>
	<img 
		:src="require('../../assets/img/star_'+((star>4)? 'on' : 'off')+'.svg')"
		style="width: 20px;"
		alt=""
	/>
</div>
	</div>
</template>

	<script>
		import Avatar from '../../assets/img/Avatar.svg';
		export default {
			name: 'userImg',
			data(){
				return {
					shadowClass: '',
					img: {
							"Avatar": Avatar,
							"bg": '',
					},
				}
			},
			components: {
				Avatar,
			},
			props: {
				star: {
					default: "",
				},
				level: {
					default: "",
				},
				src: {
						default: null,
				},
				imgClass: {
						default: "",
				},
				imgSize: {
						default: "150px",
				},
				vStyle: {
						default: "",
				},
				vWidth: {
						default: " width:100%; ",
				},
				badge: {
					default: true,
				},

			},
			mounted( THIS = this){
			},
			methods:{
				style(){
					return (this.vStyle + " " + this.vWidth + ' max-width:' + this.imgSize+'; min-width:' + this.imgSize+'; height:' + this.imgSize + '; background-image:url(' + this.showImage() + '); ');
				},
				//______________________________________________________________________
				showImage(){
					var img;
					if(this.src == null || this.src == ''){
						img = this.img.Avatar;
					} else if(this.src.includes('data:image/')){
						img = this.src;
					}	else {
						img = window.imgurl+this.src;
					}
					return img;
				}
			}
		}
	</script>
<style>
.text-success {
    color: #1b60c6 !important;
}
</style>
